import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/main/index'

Vue.use(Router)

const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
  path: '/',
  name: 'main',
  component: main,
  meta: {
    title: ""
  },
  children: []
},
{
  // 列表
  path: '/lists/:keywords',
  name: 'list',
  meta: {
    title: "商品列表"
  },
  component: () => import("../views/main/list"),
},
{
  // 登录
  path: '/login/signIn',
  name: 'signIn',
  meta: {
    title: "登录"
  },
  component: () => import("../views/login/signIn"),
},
{
  // 个人中心
  path: '/personcenter',
  name: 'myuser',
  component: () => import("../views/personcenter/myuser"),
  children: [
    {
      // 我的订单
      meta: {
        title: "我的订单"
      },
      path: 'account/account',
      name:"account",
      component: () => import("../views/personcenter/myaccount")

    },
    {
      meta: {
        title: "售后订单"
      },
      // 售后订单
      path: 'personcenter/saledorder',
      name:"saledorder",
      component: () => import("../views/personcenter/saledorder")

    },
    {
      meta: {
        title: "秘钥凭证"
      },
      // 申请秘钥
      path: 'personcenter/applykey',
      name:"applykey",
      component: () => import("../views/personcenter/applykey")

    },
    {
      meta: {
        title: "对接说明"
      },
      // 对接说明
      path: 'personcenter/dockinginstructions',
      name:"dockinginstructions",
      component: () => import("../views/personcenter/dockinginstructions")

    },
    {
      meta: {
        title: "我的选品库"
      },
      // 我的选品库
      path: 'personcenter/selectionlibrary',
      name:"selectionlibrary",
      component: () => import("../views/personcenter/selectionlibrary")

    },
   
    {
      meta: {
        title: "余额流水"
      },
      // 余额流水
      path: 'personcenter/balance',
      name:"balance",
      component: () => import("../views/personcenter/balance")

    },
    {
      meta: {
        title: "对账单"
      },
      // 对账单
      path: 'personcenter/bill',
      name:"bill",
      component: () => import("../views/personcenter/bill")

    },
    {
      meta: {
        title: "优惠券"
      },
      // 优惠券
      path: 'personcenter/coupon',
      name:"coupon",
      component: () => import("../views/personcenter/coupon")

    },
    {
      meta: {
        title: "报销专款"
      },
      // 包销专款
      path: 'personcenter/salespecail',
      name:"salespecail",
      component: () => import("../views/personcenter/salespecail")

    },
    {
      meta: {
        title: "我的足迹"
      },
      // 我的足迹
      path: 'personcenter/footprint',
      name:"footprint",
      component: () => import("../views/personcenter/footprint")

    },
    {
      meta: {
        title: "地址管理"
      },
      // 地址管理
      path: 'personcenter/address',
      name:"address",
      component: () => import("../views/personcenter/address")

    },
    {
      meta: {
        title: "企业账号认证"
      },
      // 企业账号认证
      path: 'personcenter/authentication',
      name:"authentication",
      component: () => import("../views/personcenter/authentication")

    },
    {
      meta: {
        title: "子账号列表"
      },
      // 子账号列表
      path: 'personcenter/subaccounts',
      name:"subaccounts",
      component: () => import("../views/personcenter/subaccounts")

    },
    {
      meta: {
        title: "修改密码"
      },
      // 修改密码
      path: 'personcenter/editpassword',
      name:"editpassword",
      component: () => import("../views/personcenter/editpassword")

    }
  ]
},
{
  meta: {
    title: "商品详情"
  },
  // 商品详情
  path: '/goodsdetail/goodsdetail/:id',
  name: 'goodsdetail',
  component: () => import("../views/personcenter/goodsdetail"),
},
{
  meta: {
    title: "分类商品"
  },
  // 分类商品
  path: '/categoodslist/categoodslist/:cate_id',
  name: 'categoodslist',
  component: () => import("../views/personcenter/categoodslist"),
},
]


const router = new Router({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

// 路由拦截，判断是否需要登录
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  // 通过requiresAuth判断当前路由导航是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = localStorage.getItem('token')
    // 若需要登录访问，检查是否为登录状态
    if (!token) {
      next({
        path: '/login/signIn',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js